import { IViewProduct } from "../../../interfaces-and-types";

import imagePlaceholder from "../../../assets/icons/img-placeholder.svg";
import {
  formatAsCurrency,
  formatNumberWithCommas,
  truncateStringWithEllipsis,
} from "../../../utils";

export const ProductInPaymentLinkDisplay = (props: {
  product: IViewProduct;
  quantity: number;
}) => {
  const { product, quantity } = props;

  // console.log("product in ProductInPaymentLinkDisplay: ", product);

  return (
    <div className="products-in-paymentlink--container flex-container bb">
      <div className="product-logo--container">
        <img
          src={product.product_icon ?? imagePlaceholder}
          alt="product icon"
          className="payment-link--product-icon"
        />
      </div>

      <div className="flex-box">
        <div className="flex-container col">
          <div className="flex-container">
            <div className="flex-box mr-5">
              {truncateStringWithEllipsis(product.product_name, 20)}
            </div>

            <div className="">
              {product.currency} {formatAsCurrency(quantity * product.price)}
            </div>
          </div>

          <div className="flex-container pricing-detail--row switchapp-small">
            <div className="flex-box mr-5">Qty {quantity}</div>

            {quantity > 1 ? (
              <div className="">
                {product.currency} {formatAsCurrency(product.price)} each
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
